import React from 'react';

import Button from '@atlaskit/button/default/button';
import ModalBody from '@atlaskit/modal-dialog/modal-body';
import ModalFooter from '@atlaskit/modal-dialog/modal-footer';
import ModalHeader from '@atlaskit/modal-dialog/modal-header';
import ModalTitle from '@atlaskit/modal-dialog/modal-title';
import { Text } from '@atlaskit/primitives/compiled/text';

import { type ErrorFallbackProps } from './types';

const defaultErrorTitle = "Couldn't load dialog content";
const defaultErrorText =
	'Something went wrong while loading the dialog content. Dismiss to go back';
const defaultCloseLabel = 'Close';

export const ErrorFallback = ({
	error: _,
	closeModal,
	errorTitle,
	title,
	errorText = defaultErrorText,
	errorCloseText = defaultCloseLabel,
}: ErrorFallbackProps): React.JSX.Element => {
	const modalTitle = errorTitle ?? title ?? defaultErrorTitle;

	return (
		<>
			<ModalHeader hasCloseButton closeButtonLabel={errorCloseText}>
				<ModalTitle appearance="danger">{modalTitle}</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<Text as="p">{errorText}</Text>
			</ModalBody>
			<ModalFooter>
				<Button appearance="primary" onClick={closeModal}>
					{errorCloseText}
				</Button>
			</ModalFooter>
		</>
	);
};
